import { createContext } from 'react';
import type { API } from '@trinity/chat';

export type DigitalTwinsApplication = API.App.UserApplication;

export type DigitalTwinsContextValue = {
  isLoading: boolean;
  available: boolean;
  application: DigitalTwinsApplication | null;
  basePath: string;
};

export const DigitalTwinsContext = createContext<DigitalTwinsContextValue>({
  isLoading: false,
  available: false,
  application: null,
  basePath: '/digital-twins/chat',
});
